import { useEffect, useState } from 'react'
import { checkForRig, checkMissingRig } from '../lib/checkForRig'
import { listOgsAssets } from '../lib/assetManagerApi.js'
import LoadingOverlay from './LoadingOverlay'

// Loud rig-missing overlay. Self-gating: no rig GLB AND no /ogs bundle → missing.
// Probes the server's /ogs collection before diagnosing, with a loading spinner in flight.
// A found bundle is reported via onBundleFound so the caller can enter the splat path.
// Pass active=false on render paths that never need a rig (splat / stream).
// pointerEvents:none keeps the app usable underneath so the rig can still be uploaded.
export default function CheckMissingRig({ character, active = true, onBundleFound }) {
  const [phase, setPhase] = useState('idle') // idle | probing | missing

  useEffect(() => {
    setPhase('idle')
    if (!active || !character || checkForRig(character)) return
    let cancelled = false
    setPhase('probing')
    // Failed probe counts as no bundle — applyCharacterPack's treatment; overlay is non-blocking.
    listOgsAssets(character.id).catch(() => null).then((rows) => {
      if (cancelled) return
      if (!checkMissingRig(character, rows)) {
        setPhase('idle')
        onBundleFound?.(rows)
        return
      }
      setPhase('missing')
      console.warn(`%c[App] RIG MISSING for character "${character.id}" — upload a rig GLB (content browser → Replace Rig) or OGS assets to render it`, 'color:#f59e0b;font-weight:bold')
    })
    return () => { cancelled = true }
  }, [active, character])

  if (phase === 'probing') return <LoadingOverlay label={character.label ?? character.id} />
  if (phase !== 'missing') return null

  return (
    <div data-testid="rig-missing-overlay" style={{
      position: 'absolute', inset: 0, zIndex: 40,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      pointerEvents: 'none',
    }}>
      <div style={{
        background: '#2a1d00ee', border: '1px solid #f59e0b', borderRadius: 8,
        padding: '20px 28px', maxWidth: 500, textAlign: 'center',
        color: '#fbbf24', fontFamily: 'var(--m-font)', fontSize: 13, lineHeight: 1.6,
        boxShadow: '0 4px 24px #000c',
      }}>
        <div style={{ fontSize: 26, marginBottom: 8 }}>⚠</div>
        <div style={{ fontSize: 15, marginBottom: 8, color: '#fde68a' }}>
          Rig missing for “{character.label ?? character.id}”
        </div>
        <div style={{ color: '#d9c28a' }}>
          This character has no rig uploaded yet, so there is nothing to render.
          Upload a rig GLB (content browser → New → Replace Rig) or upload OGS
          splat assets to its /ogs collection, then re-select the character or
          reload if the avatar doesn’t appear.
        </div>
      </div>
    </div>
  )
}
